module.exports = __webpack_public_path__ + "img/br.8addfe8.png";